<template>
    <div>
        <div class="d-flex justify-content-between">
            <div class="p-2 bd-highlight mt-auto mb-auto">
                <h2 style="font-weight: 600; font-size: 18px; margin-bottom: 0; color: #2F2F2F;">History</h2>
            </div>
            <div class="p-2 bd-highlight" style="width: 240px;">
                <div class="row position-relative">
                    <input
                        type="text"
                        class="form-control pr-5"
                        placeholder="Search by Kode BAST"
                        v-model="search"
                    />
                    <span
                        class="position-absolute"
                        style="right: 15px; top: 50%; transform: translateY(-50%); color: #aaa; pointer-events: none;"
                    >
                        <i class="fa fa-search"></i>
                    </span>
                </div>
            </div>
        </div>

        <div class="bg-white rounded shadow-sm mt-4">
            <div class="d-flex flex-row align-items-center justify-content-between" style="padding: 20px 20px 0 20px">
                <h3 class="h5 font-weight-semibold" style="color: #2F2F2F;">History Penerimaan QR</h3>
                <div style="background-color: white; border-radius: 4px; position: relative; margin-bottom: 20px; border: 0">
                    <span style="pointer-events: none; position: absolute; top: 0; bottom: 0; inset-inline-start: 0px; width: 40px; place-content: center; color: rgb(107 114 128); display: grid;">
                        <i class="fas fa-calendar"></i>
                    </span>
                    <flat-pickr v-model="selected.date" :config="dateRangeConfig"></flat-pickr>
                </div>
            </div>

            <ul v-if="!isPosAccount" class="nav nav-tabs" style="margin: 12px 20px 0 20px;">
                <li class="nav-item">
                    <a class="nav-link" :class="{ active: activeTab === 'md' }" href="#" @click.prevent="activeTab = 'md'">Main Dealer</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" :class="{ active: activeTab === 'pos' }" href="#" @click.prevent="activeTab = 'pos'">Pos</a>
                </li>
            </ul>

            <history-table
                v-if="isPosAccount || activeTab === 'md'"
                :exclude-child="!isPosAccount"
                :search="search"
                :start-date="filter.start_date"
                :end-date="filter.end_date"
            ></history-table>

            <history-pos-table
                v-if="!isPosAccount && activeTab === 'pos'"
                :search="search"
                :start-date="filter.start_date"
                :end-date="filter.end_date"
            ></history-pos-table>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import debounce from 'debounce';
import historyTable from './children/HistoryTable.vue'
import historyPosTable from './children/HistoryPosTable.vue'

export default {
    metaInfo : {
        title : 'History'
    },
    components : {
        historyTable,
        historyPosTable
    },
    data () {
        let start = moment().subtract(14, 'days').format("YYYY-MM-DD");
        let end = moment().format("YYYY-MM-DD");
        return {
            search : '',
            activeTab : this.$route.query.tab || 'md',
            dateRangeConfig: {
                mode: "range",
                altFormat: "d-m-Y",
                dateFormat: "Y-m-d",
                altInput: true,
                altInputClass: "flatpickr-alt",
                onClose: this.onDateRangeClose,
            },
            selected: {
                date: `${start} to ${end}`,
            },
            filter: {
                start_date: start,
                end_date: end,
            },
        }
    },
    computed: {
    isPosAccount () {
        let userData = this.$store.state.userData && this.$store.state.userData.userData;
        if (!userData || !userData.ahm_id) return false;
        let codes = [];
        try {
            codes = typeof userData.ahm_id === 'string' ? JSON.parse(userData.ahm_id) : userData.ahm_id;
        } catch (e) {
            codes = [];
        }

            return Array.isArray(codes) && codes.some(code => String(code).startsWith('P0'));
        },
    },
    beforeMount () {
        document.getElementById('content').style.background = '#F8F8F8';
    },
    beforeDestroy () {
        document.getElementById('content').style.background = '';
    },
    methods: {
        onDateRangeClose(selectedDates) {
            if (selectedDates.length === 2) {
                this.filter.start_date = moment(selectedDates[0]).format('YYYY-MM-DD');
                this.filter.end_date = moment(selectedDates[1]).format('YYYY-MM-DD');
            } else if (selectedDates.length === 1) {
                // Kalau user cuma pilih 1 tanggal lalu close popup, treat sebagai single-day filter
                this.filter.start_date = moment(selectedDates[0]).format('YYYY-MM-DD');
                this.filter.end_date = moment(selectedDates[0]).format('YYYY-MM-DD');
            }
        },
    },
}
</script>

<style>
    .flatpickr-alt {
        font-size: 14px;
        min-width: 260px;
        padding: 0 12px;
        height: 32px;
        background-color: transparent;
        padding-inline-start: 40px;
        cursor: pointer;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
    }

    .nav-tabs {
        border-bottom: 1px solid #F3F3F3;
    }

    .nav-tabs .nav-item .nav-link {
        color: #ADADAD !important;
        border: none !important;
        border-bottom: 2px solid transparent !important;
        font-weight: 600;
        padding: 12px 16px;
        background: transparent !important;
    }

    .nav-tabs .nav-item .nav-link:hover {
        color: #F36F21 !important;
    }

    .nav-tabs .nav-item .nav-link.active {
        color: #F36F21 !important;
        background: transparent !important;
        border: none !important;
        border-bottom: 2px solid #F36F21 !important;
    }
</style>